import React from 'react'
// views
import {
  AddButton,
  LevelLabelRow,
  LevelLabelsContainer,
  TrashIconWrapper
} from 'components/PageComponents/Settings/PlanTypes/Edit/Form/views'
// components
import { TrashIcon } from 'components/UI'
import { ReduxInput } from 'components/FormElements'
// types
import { WrappedFieldArrayProps } from 'redux-form/lib/FieldArray'
// utils
import { required } from 'utils/validators'

interface Props {
  label: string
}

const LevelOptions: React.FC<Props & WrappedFieldArrayProps> = ({ label, fields }) => {
  return (
    <LevelLabelsContainer>
      {fields.map((field, index) => (
        <LevelLabelRow key={index}>
          <ReduxInput name={`${field}.label`} label={label} validate={[required]} />
          <TrashIconWrapper>
            <TrashIcon onClick={() => fields.remove(index)} />
          </TrashIconWrapper>
        </LevelLabelRow>
      ))}
      <AddButton onClick={() => fields.push({})}>+ add label</AddButton>
    </LevelLabelsContainer>
  )
}

export default LevelOptions
